import React from 'react';
import { Col, Row } from 'reactstrap';
import { ExpertiseListingProps } from '../../../constants/interface/interface';

const ExpertiseListing = ({ items, columns = 3 }: ExpertiseListingProps) => {
  let colProps: object;

  switch (columns) {
    case 2:
      colProps = { lg: 6, md: 12 };
      break;
    case 4:
      colProps = { lg: 3, sm: 12 };
      break;
    case 3:
    default:
      colProps = { lg: 4, sm: 12 };
      break;
  }

  return (
    <Row className={`expertise-listing columns-${columns}`}>
      {items.map((item, index) => (
        <Col key={index} {...colProps} className="expertise-listing-item" data-aos="fade-up">
          <h3>{item.title}</h3>
          <p>{item.description}</p>
        </Col>
      ))}
    </Row>
  );
};

export default ExpertiseListing;
